import React from 'react';
import Autocomplete from '../common/Autocomplete';


export default function BasicData(props: any) {
  const action = props.action
  const handleSelection = props.handleSelection
  const ticketUpdateForm = props.ticketUpdateForm
  const statusList = props.statusList
  const prioritiesList = props.prioritiesList

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Datos Básicos</p>
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Título'
            placeholder='Título'
            disabled
            options={[]}
            value={ticketUpdateForm.title}
            name='title'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Prioridad'
            placeholder='Prioridad'
            disabled={action === 'view'}
            options={prioritiesList}
            value={ticketUpdateForm.priority}
            name='priority'
            handleSelection={handleSelection}
            required
          />
        </div>

        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Estado'
            placeholder='Estado'
            disabled={action === 'view'}
            options={statusList}
            value={ticketUpdateForm.status_n}
            name='status_n'
            handleSelection={handleSelection}
            required
          />
        </div>
      </div>
    </React.Fragment>
  );
}
